import React, { useState, useEffect } from "react";
import {
  Layout,
  Input,
  Avatar,
  Typography,
  Badge,
  Modal,
  List,
  Button,
  message,
} from "antd";
import { LogoutOutlined, SearchOutlined, BellOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

const { Header } = Layout;
const { Text } = Typography;
const LOGIN_ROUTE = "/";

const Navbar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [username, setUsername] = useState("User");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const storedUser = localStorage.getItem("username");
    if (storedUser) setUsername(storedUser);

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const notifications = [
    "Indents awaiting approval from MSPC",
    "Nutrition Mix (only 200 KG left)",
    "Deadline tomorrow: Submit FG Planning for September",
  ];

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("username");
    sessionStorage.removeItem("authToken");

    message.success("Logged out successfully!");

    const modal = Modal.success({
      title: "Logged Out",
      content: "You have logged out successfully.",
      onOk: () => navigate(LOGIN_ROUTE, { replace: true }),
      afterClose: () => navigate(LOGIN_ROUTE, { replace: true }),
    });

    setTimeout(() => {
      try { modal.destroy(); } catch {}
      if (window.location.pathname !== LOGIN_ROUTE) {
        window.location.replace(LOGIN_ROUTE);
      }
    }, 1200);
  };

  const handleNotificationClick = () => setIsModalVisible(true);

  return (
    <>
      <Header
        style={{
          background: "#0166b1",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          top: 0,
          left: collapsed ? 0 : 220,
          right: 0,
          height: 60,
          zIndex: 10,
          transition: "left 0.2s",
        }}
      >
        {/* Search Bar: hidden on very small screens */}
        {windowWidth > 576 && (
          <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              style={{ width: windowWidth < 768 ? 250 : 500, borderRadius: 8 }}
            />
          </div>
        )}

        {/* User Info & Icons */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "#fff",
          }}
        >
          <div style={{ textAlign: "right", display: windowWidth < 576 ? "none" : "block" }}>
            <Text style={{ color: "#fff", fontWeight: 500, display: "block" }}>
              Welcome {username}
            </Text>
            <Text style={{ color: "#fff", fontSize: 12, display: "block" }}>
              Project Manager
            </Text>
          </div>

          {/* Notifications: only on dashboard */}
          {location.pathname === "/dashboard" && (
            <Badge count={notifications.length} size="small">
              <Avatar
                icon={<BellOutlined />}
                style={{ cursor: "pointer", background: "#1890ff" }}
                onClick={handleNotificationClick}
              />
            </Badge>
          )}

          {/* Logout */}
          <Avatar
            icon={<LogoutOutlined />}
            style={{ cursor: "pointer", background: "#ff4d4f" }}
            onClick={handleLogout}
          />
        </div>
      </Header>

      {/* Notification Modal */}
      <Modal
        title="Notifications"
        open={isModalVisible}
        footer={[
          <Button key="close" type="primary" onClick={() => setIsModalVisible(false)}>
            Close
          </Button>,
        ]}
        onCancel={() => setIsModalVisible(false)}
      >
        <List dataSource={notifications} renderItem={(item) => <List.Item>{item}</List.Item>} />
      </Modal>
    </>
  );
};

export default Navbar;
